import Dialog from '@/shared/v2/shared/components/Dialog'
import Button from '@/shared/v2/shared/components/Button'
import Paragraph from '@/shared/v2/shared/components/Paragraph'
import { isEmpty } from 'lodash'
import { useTranslations } from 'next-intl'
import LoadingButton from '../shared/components/LoadingButton'
import { UnlinkReceivable } from '@/shared/models/invoiceModels'

type UnlinkReceivableDialogProps = {
    receivablesToUnlink: UnlinkReceivable[]
    onSubmit: () => void
    onClose: () => void
    isLoading: boolean
}

const UnlinkReceivablesDialog = ({
    receivablesToUnlink,
    onSubmit,
    onClose,
    isLoading
}: UnlinkReceivableDialogProps) => {
    const receivableTranslations = useTranslations('receivables')

    return (
        <Dialog.Root open={!isEmpty(receivablesToUnlink)} modal={true}>
            <Dialog.Content title={receivableTranslations('unlink.title')} className="max-w-[500px]">
                <Dialog.Body className="text-center p-8">
                    <Paragraph>
                        {receivableTranslations('unlink.description', { count: receivablesToUnlink.length })}
                    </Paragraph>
                </Dialog.Body>
                <Dialog.Footer>
                    <Dialog.Close asChild>
                        <Button onClick={onClose} intent="secondary" data-testid="__unlink-receivable-cancel__">
                            {receivableTranslations('unlink.cancel')}
                        </Button>
                    </Dialog.Close>
                    <LoadingButton
                        isLoading={isLoading}
                        intent="negative"
                        onClick={onSubmit}
                        data-testid="__unlink-receivable-confirm__"
                    >
                        {receivableTranslations('unlink.confirm')}
                    </LoadingButton>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog.Root>
    )
}

export default UnlinkReceivablesDialog
